import * as types from '../types/index'

export const createSubmissionReducer = (state = {}, action) => {
	switch (action.type) {
		case types.CREATE_SUBMISSION_REQUEST:
			return { loading: true }
		case types.CREATE_SUBMISSION_SUCCESS:
			return { loading: false, submission: action.payload }
		case types.CREATE_SUBMISSION_FAIL:
			return { loading: false, error: action.payload }
		case types.CREATE_SUBMISSION_RESET:
			return {}
		default:
			return state
	}
}

export const getAllSubmissionsReducer = (
	state = { submissions: { submissions: [] } },
	action
) => {
	switch (action.type) {
		case types.ADMIN_GET_ALL_SUBMISSIONS_REQUEST:
			return { loading: true, submissions: { submissions: [] } }
		case types.ADMIN_GET_ALL_SUBMISSIONS_SUCCESS:
			return { loading: false, submissions: action.payload }
		case types.ADMIN_GET_ALL_SUBMISSIONS_FAIL:
			return { loading: false, error: action.payload }
		case types.ADMIN_GET_ALL_SUBMISSIONS_RESET:
			return {}
		default:
			return state
	}
}

export const getSubmissionDetailReducer = (
	state = { submissionDetail: {} },
	action
) => {
	switch (action.type) {
		case types.GET_SUBMISSION_DETAILS_REQUEST:
			return { loading: true, submissionDetail: {} }
		case types.GET_SUBMISSION_DETAILS_SUCCESS:
			return { loading: false, submissionDetail: action.payload }
		case types.GET_SUBMISSION_DETAILS_FAIL:
			return { loading: false, error: action.payload }
		case types.GET_SUBMISSION_DETAILS_RESET:
			return { submissionDetail: {} }
		default:
			return state
	}
}

export const updateSubmissionDetailReducer = (
	state = { loading: false },
	action
) => {
	switch (action.type) {
		case types.UPDATE_SUBMISSION_DETAILS_REQUEST:
			return { loading: true }
		case types.UPDATE_SUBMISSION_DETAILS_SUCCESS:
			return { loading: false, success: true, submissionDetail: action.payload }
		case types.UPDATE_SUBMISSION_DETAILS_FAIL:
			return { loading: false, error: action.payload }
		case types.UPDATE_SUBMISSION_DETAILS_RESET:
			return {}
		default:
			return state
	}
}

export const getUserAllSubmissionsReducer = (
	state = { userSubmissions: { submissions: [] } },
	action
) => {
	switch (action.type) {
		case types.USER_GET_ALL_SUBMISSIONS_REQUEST:
			return { loading: true, userSubmissions: { submissions: [] } }
		case types.USER_GET_ALL_SUBMISSIONS_SUCCESS:
			return { loading: false, userSubmissions: action.payload }
		case types.USER_GET_ALL_SUBMISSIONS_FAIL:
			return { loading: false, error: action.payload }
		case types.USER_GET_ALL_SUBMISSIONS_RESET:
			return {}
		default:
			return state
	}
}

export const userGetSubmissionDetailReducer = (
	state = { userSubmissionDetail: {} },
	action
) => {
	switch (action.type) {
		case types.USER_GET_SUBMISSION_DETAILS_REQUEST:
			return { loading: true, userSubmissionDetail: {} }
		case types.USER_GET_SUBMISSION_DETAILS_SUCCESS:
			return { loading: false, userSubmissionDetail: action.payload }
		case types.USER_GET_SUBMISSION_DETAILS_FAIL:
			return { loading: false, error: action.payload }
		case types.USER_GET_SUBMISSION_DETAILS_RESET:
			return { userSubmissionDetail: {} }
		default:
			return state
	}
}
